module.exports = __webpack_public_path__ + "img/link-banner-tw.d27e6d65.png";